import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { Actions } from '../actions';
import { ActionTypes, ProfileState } from './types';

const initialState: ProfileState = {
    gridSize: 'large'
};

const profileReducer = (state = initialState, action: Actions): ProfileState => {
    switch (action.type) {
        case ActionTypes.SET_GRID_SIZE: {
            return {
                ...state,
                gridSize: action.payload
            };
        }
        default:
            return state;
    }
};
export const name = 'profile';
export const useProfileStore: TypedUseSelectorHook<ProfileState> = (selector, ...args) =>
    useSelector((store: any) => selector(store[name]), ...args);
export default profileReducer;
